/**
 * A specimen can be recorded before its source cycle is known. The explicit
 * sentinel lets a patient opt out of a contextual cycle link without losing
 * the specimen record or silently attaching it to the current cycle.
 */
export const UNLINKED_SPECIMEN_CYCLE_ID = "__not_linked__";

export function resolveSpecimenCycleId({
  relatedCycleId,
  contextCycleId,
}: {
  relatedCycleId: string | null | undefined;
  contextCycleId: string | null | undefined;
}): string | undefined {
  if (relatedCycleId === UNLINKED_SPECIMEN_CYCLE_ID) return undefined;
  return relatedCycleId ?? contextCycleId ?? undefined;
}

export function shouldCreateSpecimenCycle({
  selectedCycleId,
  relatedCycleId,
}: {
  selectedCycleId: string | undefined;
  relatedCycleId: string | null | undefined;
}): boolean {
  return (
    selectedCycleId === undefined &&
    relatedCycleId !== null &&
    relatedCycleId !== undefined &&
    relatedCycleId !== UNLINKED_SPECIMEN_CYCLE_ID
  );
}
